import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import { getPowerAmountApi } from '@/api';
import { dbDataHandle } from '@/store/function/common/index';

import downloadCsv from 'download-csv';
export default {
  name: 'Etoday',
  props: {
    filename: {
      type: String,
      default: '下載檔案'
    }
  },
  data: function data() {
    return {
      hasNoData: false,
      small: true,
      etodayData: [],
      tableField: [{
        key: 'date',
        label: '月份'
      }, {
        key: 'acpGoal',
        label: '目標發電量 (kWh)'
      }, {
        key: 'acpActual',
        label: '實際發電量 (kWh)'
      }, {
        key: 'guaranteePower',
        label: '保證發電量 (kWh)'
      }, {
        key: 'irrGoal',
        label: '目標日照量 (kWh/m²)'
      }, {
        key: 'irrActual',
        label: '實際日照量 (kWh/m²)'
      }, {
        key: 'accAcpGoal',
        label: '目標累積發電量 (kWh)'
      }, {
        key: 'accAcpAll',
        label: '實際累積發電量 (kWh)'
      }, {
        key: 'accGuaranteePower',
        label: '保證累積發電量 (kWh)'
      }],
      dataClassArr: ['發電量', '日照量', '累積發電量'],
      dataClass: ['發電量', '日照量', '累積發電量'],
      eTodayChart: {
        chart: {
          height: 350,
          backgroundColor: null,
          events: {
            load: function load() {
              this.showLoading();
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          floating: false
        },
        yAxis: [{
          title: {
            text: '發電量 (kWh)'
          }
        }, {
          title: {
            text: '日照量 (kWh/m²)'
          },
          opposite: true
        }, {
          title: {
            text: '累積發電量 (kWh)'
          },
          opposite: true
        }],
        tooltip: {
          shared: true
        },
        series: [{
          color: 'rgb(255, 192, 0)',
          type: 'column',
          name: '目標發電量 (kWh)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(124,181,236)',
          type: 'column',
          name: '實際發電量 (kWh)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(31, 209, 150)',
          type: 'column',
          name: '保證發電量 (kWh)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(155, 102, 196)',
          name: '目標日照量 (kWh/m²)',
          data: [],
          yAxis: 1,
          visible: true
        }, {
          color: 'rgb(230, 101, 146)',
          name: '實際日照量 (kWh/m²)',
          data: [],
          yAxis: 1,
          visible: true
        }, {
          color: 'rgb(255, 162, 0)',
          name: '目標累積發電量 (kWh)',
          data: [],
          yAxis: 2,
          visible: true
        }, {
          color: 'rgb(86, 160, 232)',
          name: '實際累積發電量 (kWh)',
          data: [],
          yAxis: 2,
          visible: true
        }, {
          color: 'rgb(2, 181, 122)',
          name: '保證累積發電量 (kWh)',
          data: [],
          yAxis: 2,
          visible: true
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      },
      etodayDataForExcel: []
    };
  },
  methods: {
    getEtodayData: function getEtodayData(months) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _etodayData$data, etodayData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.eTodayChart.series.forEach(function (x) {
                  x.data = [];
                });
                _context.prev = 1;
                _context.next = 4;
                return getPowerAmountApi(_this.$route.query.fid, _this.$route.query.siteName + '.json', months);
              case 4:
                etodayData = _context.sent;
                if (etodayData !== null && etodayData !== void 0 && (_etodayData$data = etodayData.data) !== null && _etodayData$data !== void 0 && _etodayData$data.success) {
                  // 複製 etodayData、etodayDataForExcel 不能 refer 同個 data
                  // renderData() 會改動 etodayData 資料

                  // 下載資料用
                  _this.etodayDataForExcel = etodayData.data.data;

                  // 顯示圖表、表格用，copy 避免改動到 rawData (etodayData.data.data)
                  _this.etodayData = etodayData.data.data.map(function (item) {
                    var copy = Object.assign({}, item);
                    return copy;
                  });
                  _this.renderData();
                  _this.hasNoData = false;
                }
                _context.next = 13;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log('getEtodayData error: ', _context.t0);
                _this.hasNoData = true;
                _context.t0.msg && _this.$swal(_context.t0.msg);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    renderData: function renderData() {
      var _this2 = this;
      this.eTodayChart.xAxis.categories = [];
      this.eTodayChart.series.forEach(function (x) {
        x.data = [];
      });
      this.etodayData.forEach(function (x) {
        _this2.eTodayChart.xAxis.categories.push(x.date);
        // 圖表、表格 是共用 this.etodayData 資料，直接 dbDataHandle 改變原始資料，顯示處理過的數據
        x.acpGoal = x.acpGoal === null ? null : dbDataHandle(x.acpGoal);
        x.acpActual = x.acpActual === null ? null : dbDataHandle(x.acpActual);
        x.guaranteePower = x.guaranteePower === null ? null : dbDataHandle(x.guaranteePower);
        x.irrGoal = x.irrGoal === null ? null : dbDataHandle(x.irrGoal);
        x.irrActual = x.irrActual === null ? null : dbDataHandle(x.irrActual);
        x.accAcpGoal = x.accAcpGoal === null ? null : dbDataHandle(x.accAcpGoal);
        x.accAcpAll = x.accAcpAll === null ? null : dbDataHandle(x.accAcpAll);
        x.accGuaranteePower = x.accGuaranteePower === null ? null : dbDataHandle(x.accGuaranteePower);
        _this2.eTodayChart.series[0].data.push(x.acpGoal);
        _this2.eTodayChart.series[1].data.push(x.acpActual);
        _this2.eTodayChart.series[2].data.push(x.guaranteePower);
        _this2.eTodayChart.series[3].data.push(x.irrGoal);
        _this2.eTodayChart.series[4].data.push(x.irrActual);
        _this2.eTodayChart.series[5].data.push(x.accAcpGoal);
        _this2.eTodayChart.series[6].data.push(x.accAcpAll);
        _this2.eTodayChart.series[7].data.push(x.accGuaranteePower);
      });
      this.hideHighChartLoading();
    },
    hideHighChartLoading: function hideHighChartLoading() {
      this.$nextTick(function () {
        if (this.$refs && this.$refs.chart) {
          this.$refs.chart.chart.hideLoading();
          this.eTodayChart.chart.events = {};
        }
      });
    },
    downloadAnalysis: function downloadAnalysis() {
      var downloadArr = [];
      var fields = ['name'];
      fields = fields.concat(this.eTodayChart.xAxis.categories);
      this.eTodayChart.series.forEach(function (x) {
        downloadArr.push({
          name: x.name
        });
      });
      var download = [];
      this.eTodayChart.series.forEach(function (_) {
        download.push({
          data: []
        });
      });
      this.etodayDataForExcel.forEach(function (obj) {
        var acpGoal = obj.acpGoal === null ? null : obj.acpGoal;
        var acpActual = obj.acpActual === null ? null : obj.acpActual;
        var guaranteePower = obj.guaranteePower === null ? null : obj.guaranteePower;
        var irrGoal = obj.irrGoal === null ? null : obj.irrGoal;
        var irrActual = obj.irrActual === null ? null : obj.irrActual;
        var accAcpGoal = obj.accAcpGoal === null ? null : obj.accAcpGoal;
        var accAcpAll = obj.accAcpAll === null ? null : obj.accAcpAll;
        var accGuaranteePower = obj.accGuaranteePower === null ? null : obj.accGuaranteePower;
        download[0].data.push(acpGoal);
        download[1].data.push(acpActual);
        download[2].data.push(guaranteePower);
        download[3].data.push(irrGoal);
        download[4].data.push(irrActual);
        download[5].data.push(accAcpGoal);
        download[6].data.push(accAcpAll);
        download[7].data.push(accGuaranteePower);
      });
      this.eTodayChart.xAxis.categories.forEach(function (x, xindex) {
        downloadArr.forEach(function (y, yindex) {
          y["".concat(x)] = download[yindex].data[xindex];
        });
      });
      downloadCsv(downloadArr, fields, this.filename);
    }
  },
  mounted: function mounted() {},
  watch: {
    dataClassArr: function dataClassArr(newValue, oldValue) {
      var _this3 = this;
      var setData = [{
        name: '發電量',
        dataName: ['目標發電量 (kWh)', '實際發電量 (kWh)', '保證發電量 (kWh)']
      }, {
        name: '日照量',
        dataName: ['目標日照量 (kWh/m²)', '實際日照量 (kWh/m²)']
      }, {
        name: '累積發電量',
        dataName: ['目標累積發電量 (kWh)', '實際累積發電量 (kWh)', '保證累積發電量 (kWh)']
      }];
      if (oldValue !== newValue) {
        this.eTodayChart.series.forEach(function (x) {
          x.visible = false;
        });
        setData.forEach(function (x) {
          if (newValue.includes(x.name)) {
            x.dataName.forEach(function (y) {
              _this3.eTodayChart.series.find(function (z) {
                return z.name === y;
              }).visible = true;
            });
          }
        });
      }
    }
  }
};